export default __webpack_public_path__ + "static/media/dart.75456aab.png";